module.exports = __webpack_public_path__ + "static/media/pumpwhiz-3.b2c7f7ac.png";